import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { AIQueryKeys } from '../queries'

const useAIObjects = () => {
  const { aiServiceApi: api } = useApi()

  const queryKey = [AIQueryKeys.AIObjects]
  const query = useQuery({
    queryKey,
    queryFn: () => api.aiObjects.getAllAsync(),
    refetchOnMount: false,
  })

  return useMemo(
    () => ({
      loading: query.isLoading || query.isFetching,
      loaded: query.isSuccess,
      aiObjects: query.data ?? [],
    }),
    [query.isLoading, query.isFetching, query.isSuccess, query.data]
  )
}

export default useAIObjects
